export const MPOG_INDICATOR_FIELDS = [
  'operatingRoom',
  'surgicalService',
  'admissionType',
  'measureEndTime',
  'techniqueGeneral',
  'techniqueNeuraxial',
  'techniqueBlock',
];

export const MPOG_LINK = 'https://caseviewer.mpog.org/chart?id={caseId}';

export const QUALITY_METRICS_CASE_FILTER = {
  ALL: 'all',
  NON_COMPLIANT: 'non_compliant',
  COMPLIANT: 'compliant',
};

export const MIN_CASES_FOR_TREND = 3;

/** The most users `GET /:id/users/trends` will compare on one chart. */
export const MAX_COMPARED_USERS = 5;

export const PULL_KEY_MAX = 100;

/** The external systems a user can carry provider names for (the sync-service mappers that name providers). */
export const PROVIDER_IDENTIFICATION_PROVIDERS = {
  MPOG: 'mpog',
  KECK: 'keck',
  GWU: 'gwu',
};

/** Display name of each provider, shown on the provider-name tags and pickers. */
export const PROVIDER_IDENTIFICATION_LABELS = {
  [PROVIDER_IDENTIFICATION_PROVIDERS.MPOG]: 'MPOG',
  [PROVIDER_IDENTIFICATION_PROVIDERS.KECK]: 'Keck',
  [PROVIDER_IDENTIFICATION_PROVIDERS.GWU]: 'GWU',
};

/** Longest provider name `PUT /v1/user/:id` accepts (trimmed). */
export const PROVIDER_IDENTIFICATION_VALUE_MAX = 200;

/** Most provider names one user can hold in an organization, across providers. */
export const PROVIDER_IDENTIFICATION_MAX = 20;

/**
 * The parsers the sync service can run on an export. Set per organization
 * (`mapper.default` on its quality-metric configuration) and overridable per
 * metric; `null` on a metric means "use the organization's default".
 *
 * @type {import('../api/quality-metric-rq.service.api').PullMapper[]}
 */
export const PULL_MAPPERS = ['mpog', 'utmb', 'keck', 'gwu', 'unc'];

/**
 * Server `code` values the quality-metric screens branch on, rather than on the
 * HTTP status alone.
 *
 * `CONFIGURATION_NOT_FOUND` is the one that is not a failure: an organization
 * nobody has configured has no document, which is an empty form and no default
 * mapper to resolve a metric's `null` against. `RUN_WINDOW_TAKEN` means another
 * run of the same organization and source already covers that window, which
 * names the Scheduler job. `SCHEDULER_NOT_MANAGED` means this environment owns
 * no Scheduler jobs, and `SCHEDULER_NOT_FOUND` that the run outlived its job
 * and needs a re-sync before it can be triggered. `PROVIDER_IDENTIFICATION_TAKEN`
 * comes from the user edit (`PUT /v1/user/:id`): another user of the
 * organization already holds that provider name.
 */
export const QUALITY_METRIC_ERROR_CODES = {
  PULL_KEY_TAKEN: 'PULL_KEY_TAKEN',
  PROVIDER_IDENTIFICATION_TAKEN: 'PROVIDER_IDENTIFICATION_TAKEN',
  CONFIGURATION_NOT_FOUND: 'QUALITY_METRIC_CONFIGURATION_NOT_FOUND',
  RUN_WINDOW_TAKEN: 'RUN_WINDOW_TAKEN',
  RUN_NOT_FOUND: 'RUN_NOT_FOUND',
  SCHEDULER_NOT_MANAGED: 'SCHEDULER_NOT_MANAGED',
  SCHEDULER_NOT_FOUND: 'SCHEDULER_NOT_FOUND',
};

export const PULL_LOOKBACK_MIN_MONTHS = 1;
export const PULL_LOOKBACK_MAX_MONTHS = 24;

export const TREND_STATUS = {
  UP: 'up',
  DOWN: 'down',
  NO_CHANGE: 'no_change',
  NA: 'na',
};
